import usePersistDataStore from '@/stores/persistData'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import appConfig from '@/config'
import { UploadChangeParam } from 'antd/lib/upload'
import defaultImg from '@/assets/image/defaultSiteImage.png'
import { Upload } from 'antd'
import { PlusOutlined } from '@ant-design/icons'

interface Props {
  value?: string[]
  onChange?: (value: string[]) => void
  id?: string
}

const UpdateImg: React.FC<Props> = ({ value, onChange, id }) => {
  const { t } = useTranslation()
  const { token } = usePersistDataStore(state => state.userInfo)
  const lang = usePersistDataStore(state => state.lang)

  const headers = useRef({
    token,
    lang,
    prefix: appConfig.prefix,
    'prefix-name': appConfig.prefix_name,
  })

  const handleChange = (params: UploadChangeParam) => {
    const { file } = params
    if (file.status === 'done') {
      onChange?.([file.response.url])
    }
  }

  return (
    <div className='upload-site-img' id={id}>
      <div className='site-img-place'>
        <img className='site-img img-border' src={defaultImg} />
        <div className='img-name'>{t('site.defaultImage')}</div>
      </div>
      <div className='site-img-place'>
        <Upload
          name='file'
          action={appConfig.apiUrl + 'common/upload_file'}
          maxCount={1}
          onChange={handleChange}
          headers={headers.current}
          showUploadList={false}>
          {value && value.length > 0 ? (
            <img src={appConfig.staticFile + value[0]} className='site-img upload-btn' />
          ) : (
            <div className='upload-btn'>
              <PlusOutlined />
            </div>
          )}
        </Upload>
        <div className='img-name'>{t('site.customizeImage')}</div>
      </div>
    </div>
  )
}

export default UpdateImg
